import axios from 'axios';

export const authRequest = (url, config) => {
  
  const promise = axios.request({
    ...config,
    url
  }).then((response) => {
    return response.data;    
  }).catch((error) => {            
    throw error.response;
  });
  
return promise;
}